import createSagaMiddleware from 'redux-saga';

import { AQA_KEY, DEV_KEY } from 'constants/dev';

import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import rootSaga from './rootSaga';
import rootReducer from './rootReducer';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    __getState: any;
  }
}

const sagaMiddleware = createSagaMiddleware();

// TODO: https://welltech.atlassian.net/browse/UPP-90

const configureStore = () => {
  const composeEnhancers = (process.env.ENV !== 'prod' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(sagaMiddleware)));

  sagaMiddleware.run(rootSaga);

  return { store };
};

export const { store } = configureStore();

const urlParams = new URLSearchParams(window.location.search);
const refParams = urlParams.get(DEV_KEY);

if (refParams === AQA_KEY || localStorage.getItem(DEV_KEY)) {
  localStorage.setItem(DEV_KEY, AQA_KEY);

  window['__getState'] = () => store.getState();
}

export type Store = ReturnType<typeof store.getState>;
export type Dispatch = typeof store.dispatch;
